export var MAX_SUPPORTED_NAME_LENGTH = 254;
export var MAX_SUPPORTED_DESCRIPTION_LENGTH = 1024;
